import { inject } from 'mobx-react';
import * as React from 'react';

import { ContextStore } from 'bernie-core';

import { DeviceInformation } from '@shared-ui/viewport-context';

import { MultiItemStore } from 'stores/multi-item-store';

interface TargetableLinkProps {
  context?: ContextStore;
  multiItem?: MultiItemStore;
  children?: any;
}

export const TargetableLink: React.FunctionComponent<TargetableLinkProps> = inject(
  'context',
  'multiItem'
)(({ context, multiItem, children }) => {
  const target = determineTarget(context?.deviceInformation, multiItem?.isPackageShoppingPath());

  return React.cloneElement(children, { ...children.props, target });
});

TargetableLink.displayName = 'TargetableLink';

export function determineTarget(deviceInformation: DeviceInformation, isPackagePath: boolean): string {
  let target: string | undefined = '_blank';

  if (isPackagePath) {
    target = '_blank';

    if (deviceInformation?.mobile || deviceInformation?.tablet) {
      target = '_self';
    }
  } else if (deviceInformation?.mobile && !deviceInformation?.tablet) {
    target = undefined;
  } else {
    target = '_blank';
  }

  return target;
}
